export default "__VITE_ASSET__hM6VIkcZ__"